<div class=" review d-flex flex-sm-row flex-column">
    <div class="card review">
        <div class="card-body">
          <h5 class="card-title"> <img class="icon" src="../../../assets/icons/quotes-left.png" alt=""></h5>
          <p class="card-text description">Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nemo, tempore facere repellat sequi voluptatem delectus assumenda eius cum ab laborum aliquid debitis suscipit vitae, inventore placeat perferendis ad corrupti corporis.</p>
        </div>
        <div class="image  ">
            <img src="../../../assets/review image.png">
            <p class="name ">Mimo Miaomiao</p>
        </div>
      </div>

</div>
